import Header from "../components/Header";
import Footer from "../components/Footer";
import { Container, Typography } from "@mui/material";
import Flexbox from "../components/Flexbox";
import Spacebox from "../components/Spacebox";
import { isMobile } from "react-device-detect";

// Use the new embed code you provided:
const GHLFORM = `<iframe
  src="https://api.leadconnectorhq.com/widget/form/IoSFgBWbRqo08X7cuUXA"
  style="width:100%;height:100%;border:none;border-radius:3px"
  id="inline-IoSFgBWbRqo08X7cuUXA"
  data-layout="{'id':'INLINE'}"
  data-trigger-type="alwaysShow"
  data-trigger-value=""
  data-activation-type="alwaysActivated"
  data-activation-value=""
  data-deactivation-type="neverDeactivate"
  data-deactivation-value=""
  data-form-name="Credit Repair Form"
  data-height="1204"
  data-layout-iframe-id="inline-IoSFgBWbRqo08X7cuUXA"
  data-form-id="IoSFgBWbRqo08X7cuUXA"
  title="Credit Repair Form"
></iframe>
<script src="https://link.msgsndr.com/js/form_embed.js"></script>`;

const CreditCard = ({ title }) => {
  // Make sure the page title updates
  document.querySelector("title").innerHTML = title;

  return (
    <div className="creditcard">
      <Header />

      <section>
        <Flexbox justifyContent="center" alignItems="center">
          <Container>
            <Spacebox padding="20px" />

            {/* Page Title (mimics Booking but with Apply text) */}
            <Typography
              variant="h3"
              style={{
                textAlign: "center",
                fontSize: isMobile ? "25px" : "30px",
              }}
            >
              Apply for Business Funding
            </Typography>
            <Spacebox padding="10px" />

            {/* Subtext (mimics Booking but with Apply subtitle) */}
            <Typography
              style={{ opacity: 0.6, textAlign: "center", fontSize: "18px" }}
            >
              Get business funding with flexible terms and fast approvals.
            </Typography>
            <Spacebox padding="50px" />

            {/* Embedded Form Container (same structure as Booking’s calendar) */}
            <div
              className="margin-auto"
              style={{
                padding: isMobile ? "0px" : "20px",
                borderRadius: "10px",
                border: isMobile ? "0px solid transparent" : "1px solid #4A3FFF20",
                height: "500px",
                width: isMobile ? "100%" : "700px",
              }}
              dangerouslySetInnerHTML={{ __html: GHLFORM }}
            ></div>

            <Spacebox padding="20px" />
            <Spacebox padding="20px" />
          </Container>
        </Flexbox>
      </section>

      <Footer />
    </div>
  );
};

export default CreditCard;
